<template>
    <div class="loader-full">
        <div class="container-gif">
            <img src="../../../public/img/loaders/loader-huddle.gif" alt="" class="gif">
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
    .loader-full{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: #30353b;
        position: absolute;
        top: 0;
        z-index: 1100;
    }

    @media only screen and (max-width: 750px){
        .loader-full{
            height: 100vh;
        }
    }
</style>
